import Sortable from "sortablejs";

/**
 * Provides Drag n Drop Sorting functionality using SortableJS. When an element is dropped,
 * it pushes an event, `reposition`, to the parent LiveView which allows the LiveView to then
 * perform any logic to store the repositioning.
 *
 * This Hook goes on the parent element, and IDs need to be added to child elements.
 *
 * ### Examples
 *
 * <ul id="parent-list" hook="DragAndDropSortable">
 *  <li :for={row <- @rows} data-id={row.id}>
 *    <%= row.title %>
 *  </li>
 * </ul>
 *
 *
 * def handle_event("reposition", %{"id" => row_id, "new" => new, "old" => old}, socket) do
 *  # Update records with new positioning.
 *  {:noreply, socket}
 * end
 *
 */

export const DragAndDropSortable = {
  mounted() {
    new Sortable(this.el, {
      animation: 150,
      delay: 0,
      dragClass: "drag-item",
      ghostClass: "drag-ghost",
      onEnd: (e) => {
        const params = { old: e.oldIndex, new: e.newIndex, ...e.item.dataset };
        this.pushEventTo(this.el, "reposition", params);
      },
    });
  },
};
